import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import {
  APP_NAME,
  APP_NAME_SHORT,
  LS_CURRENT_USER,
  LS_IS_LOGOUT_ACTION,
  LS_SIDEBAR,
  ROLE_GROUP_EXPORT_CUSTOMER,
  ROLE_GROUP_TREASURY,
} from 'src/app/constants/app.constant';
import { CommonService } from 'src/app/services/common/common.service';
import { UrlUtilService } from 'src/app/services/common/url-util.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/authorization/auth.service';
import { StringUtilService } from 'src/app/services/common/string-util.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  constructor(
    private common: CommonService,
    private urlUtil: UrlUtilService,
    private _authService: AuthService,
    private _router: Router,
    private stringUtil: StringUtilService
  ) {}

  //----------------------------  Constant  --------------------------------//
  readonly version = environment.production ? null : environment.envVersion;
  readonly APP_NAME = APP_NAME;
  readonly APP_NAME_SHORT = APP_NAME_SHORT;

  //----------------------------  Input / Output  --------------------------------//
  @Input() sidebarVisible: boolean = true;
  @Output() sidebarVisibleChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  //----------------------------  Valiable  --------------------------------//
  userFullName: string = 'Dev Local';
  userShortName: string = 'DL';
  userRoleName: string = 'Develop';
  menuItems: MenuItem[] = [];

  isExpCus: boolean = false;

  isMobile = this.common.isMobile();

  ngOnInit() {
    setTimeout(() => {
      // this.userFullName = this.common.getLocalStorage(LS_CURRENT_USER)?.name;
    }, 100);
    this.isExpCus =
      ((this._authService.userGroup && this._authService.userGroup[0].id) ??
        ROLE_GROUP_TREASURY) === ROLE_GROUP_EXPORT_CUSTOMER;
    this.userFullName = JSON.parse(this._authService.currentUser)?.name;
    if (!!this.userFullName) {
      let name = this.userFullName.split(' ');
      if (name.length > 1) {
        this.userShortName = name[0][0] + '' + (name[1][0] || '');
      } else {
        this.userShortName = name[0][0];
      }
    }
    if (this._authService.userGroup && this._authService.userGroup.length) {
      this.userRoleName = this._authService.userGroup[0].displayName;
    }
    this.menuItems = [
      // {
      //   label: 'User',
      //   items: [
      //     {
      //       label: 'Profile',
      //       icon: 'pi pi-user',
      //       command: () => {
      //         this.openUserProfile();
      //       },
      //     },
      //   ],
      // },
      {
        // label: 'Authorization',
        label: `<span class="fw-bold menu-text-primary">${this.userFullName}</span><br ><span>${this.userRoleName}</span>`,
        escape: false,
        items: [
          // {
          //   label: 'Change Password',
          //   icon: 'fa-solid fa-lock',
          //   command: () => {
          //     this.changePassword();
          //   },
          // },
          {
            label: 'Sign Out',
            icon: 'pi pi-sign-out',
            command: () => {
              this.signOut();
            },
            id: 'sign-out-btn',
          },
        ],
      },
    ];
    if (this.isExpCus) {
      this.menuItems[0].items?.unshift({
        label: 'Change Password',
        icon: 'fa-solid fa-lock',
        command: () => {
          this.changePassword();
        },
      });
    }
  }

  //#region Function
  signOut() {
    // call logout
    this.common.setLocalStorage(LS_IS_LOGOUT_ACTION, 'true');
    setTimeout(() => {
      this._authService.signOut();
      this._authService.signOutMsal();
    });
    // this._router.navigate(['sign-in']);
  }

  changePassword() {
    this._authService.b2cResetPassword();
  }

  openUserProfile() {
    this.urlUtil.openNewTab('/user/user-profile', {});
  }
  //#endregion

  //#region event function
  onClickToggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
    this.common.setLocalStorage(
      LS_SIDEBAR,
      this.sidebarVisible ? 'show' : 'hide'
    );
    this.sidebarVisibleChange.emit(this.sidebarVisible);
  }
  //#endregion
}
